import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import './ClientArea.css'
import TitleText from '../../../../Components/TitleText/TitleText';
import Carousel from 'react-bootstrap/Carousel';





const ClientArea = (props) => {

    const array = [];
    props.comment.map((item) => {

        if (item.approved) {
            array.push(item)
        }

        return array;
    })




    return (

        <div id="clientArea" >

            <div className='background '>
                <div className='container'>
                    <div className='row'>
                        <div className="col-md-6 col-sm-12 col-lg-6 ">
                            <TitleText title1="client" title2="Area" position="center" />

                        </div>
                        <div className="col-md-6 col-sm-12 col-lg-6 boxContainer">
                            <div className='box'>
                                <h2 className='clientSay' >what our client's say?</h2>
                                <hr></hr>

                                <Carousel className='h-100' variant="light" indicators={true} controls={false} >
                                    {
                                        array.map((item) => {
                                            return (


                                                <Carousel.Item key={item.id}>
                                                    <h2>{(item.name)}</h2>
                                                    <p>{(item.comment)}</p>

                                                </Carousel.Item>



                                            )
                                        })
                                    }


                                </Carousel>
                            </div>

                        </div>
                    </div>
                </div>

            </div >

            <div className='lightBackground'>
                <div className='container '>
                    <div className="row  ">
                        <div className="col-md-6 col-sm-12 col-lg-6 mt-2 mb-5 ">
                            <Swiper


                                slidesPerView={4}
                                spaceBetween={10}

                                slidesPerGroup={4}
                                loop={true}
                                loopFillGroupWithBlank={false}
                                autoplay={
                                    {
                                        delay: 3000
                                    }

                                }


                                navigation={false}
                                modules={[Autoplay, Pagination, Navigation]}
                                className="mySwiper"
                            >
                                {
                                    props.logo.map((item) => {
                                        return (
                                            <SwiperSlide key={(item.id)}> <img className='icon' src={(item.img)} alt="" /></SwiperSlide>
                                        )
                                    }
                                    )
                                }


                            </Swiper>


                        </div>
                    </div>


                </div>
            </div>
        </div >
    );
};

export default ClientArea;